import { useForm } from 'react-hook-form';

import {
  Button,
  Input,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Text,
} from '@chakra-ui/react';
import { useRef, useState } from 'react';
import Container from '../components/Container';

const ConfirmForgotPassword = () => {
  const search = new URLSearchParams(window.location.search);
  const [error, setError] = useState(search.has('error'));
  const ref = useRef();

  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm();

  const onSubmit = async (data) => {
    setError(false);
    const asd = window.AmazonCognitoAdvancedSecurityData.getData(data.user, '', search.get('client_id'));
    ref.current.asd.value = asd;
    ref.current.submit();
    return true;
  };

  const onHandleSubmit = (ev) => {
    ev.stopPropagation();
    ev.preventDefault();
    handleSubmit(onSubmit)();
  };

  return (
    <Container py="8">
      {/* eslint-disable-next-line max-len */}
      <form ref={ref} onSubmit={onHandleSubmit} action={`${process.env.REACT_APP_BACKEND}/auth/confirmForgotPassword${window.location.search}`} method="POST">
        <Text fontSize="sm" color="gray.600">
          We have sent a password reset code to your email. Enter it below to reset your password.
        </Text>
        {error && (
          <Text my="2" fontSize="sm" color="red.500">
            Could not reset password for the account, please contact support or try again
          </Text>
        )}

        <FormControl my="6" isInvalid={errors.code}>
          <FormLabel mb="0.5" fontSize="sm">Code</FormLabel>
          <Input size="sm" type="text" placeholder="Code" {...register('code', { required: true })} />
          <FormErrorMessage>The code is required</FormErrorMessage>
        </FormControl>

        <FormControl my="6" isInvalid={errors.password}>
          <FormLabel mb="0.5" fontSize="sm">Password</FormLabel>
          <Input size="sm" type="password" placeholder="New password" {...register('password', { required: true })} />
          <FormErrorMessage>The new password is required</FormErrorMessage>
        </FormControl>

        <FormControl my="6" isInvalid={errors.confirmPassword}>
          <FormLabel mb="0.5" fontSize="sm">Enter New Password Again</FormLabel>
          <Input size="sm" type="password" placeholder="New password" {...register('confirmPassword', { required: true })} />
          <FormErrorMessage>Please confirm the new password</FormErrorMessage>
        </FormControl>

        <input type="hidden" className="form-control" name="asd" />
        <Button colorScheme="blue" type="submit" size="sm" isLoading={isSubmitting} px="10">Reset my password</Button>
      </form>
    </Container>
  );
};

export default ConfirmForgotPassword;
